import React, { Suspense } from "react";

import type { UploadDocumentsProps } from "./UploadDocumentsInner";
import styles from "./upload-documents.module.css";

const LazyUploadDocuments = React.lazy(() =>
  import("./UploadDocumentsInner").then((mod) => ({
    default: mod.UploadDocuments,
  })),
);

export const UploadDocuments = (props: UploadDocumentsProps) => {
  const fallbackHeight = props.height ?? 200;

  return (
    <Suspense
      fallback={
        <div
          className={styles.fallback}
          role="status"
          style={{ minHeight: fallbackHeight }}
        >
          Preparing uploader…
        </div>
      }
    >
      <LazyUploadDocuments {...props} />
    </Suspense>
  );
};

export type { UploadDocumentsProps } from "./UploadDocumentsInner";
